module.exports = __webpack_public_path__ + "static/img/flutter.23a7208.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/flutter.jpeg
// module id = hqM5
// module chunks = 1